<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Ybe Casteleyn is one of Europe’s most sought-after psychotraumatologists, with clients from all over Europe, but also Syria, USA and Afghanistan. She has worked with all kinds of trauma: people haunted by their past, survivors of child abuse, refugees, victims of accidents and crime, victims of terrorist attacks.</p><br/>
<p style="text-indent: 0em;">Nowadays, she organises online trauma courses for fellow-therapists, psychologists, midwifes, GPs, gynaecologists and other professionals in the field of mental health. Ybe is an avid advocate for the ‘trauma-informed society’.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3d6ee0a5